const g = window;
const d = window.document;
declare const WeixinJSBridge: any | undefined;

// 所有菜单项列表
// 基本类
type MenuBaseItem =
    | "menuItem:exposeArticle" // 举报
    | "menuItem:setFont" // 调整字体
    | "menuItem:dayMode" // 日间模式
    | "menuItem:nightMode" // 夜间模式
    | "menuItem:refresh" // 刷新
    | "menuItem:profile" // 查看公众号（已添加）
    | "menuItem:addContact"; // 查看公众号（未添加）
// 传播类
type MenuShareItem =
    | "menuItem:share:appMessage" // 发送给朋友
    | "menuItem:share:timeline" // 分享到朋友圈
    | "menuItem:share:qq" // 分享到QQ
    | "menuItem:share:weiboApp" // 分享到Weibo
    | "menuItem:favorite" // 收藏
    | "menuItem:share:facebook" // 分享到FB
    | "menuItem:share:QZone"; // 分享到 QQ 空间

// 保护类
type MenuProtectedItem =
    | "menuItem:editTag" // 编辑标签
    | "menuItem:delete" // 删除
    | "menuItem:copyUrl" // 复制链接
    | "menuItem:originPage" // 原网页
    | "menuItem:readMode" // 阅读模式
    | "menuItem:openWithQQBrowser" // 在QQ浏览器中打开
    | "menuItem:openWithSafari" // 在Safari中打开
    | "menuItem:share:email" // 邮件
    | "menuItem:share:brand"; // 一些特殊公众号

type MenuItem = MenuBaseItem | MenuProtectedItem | MenuShareItem;
export namespace WechatJSBridge {
  export function ready(fn: () => void) {
    if (typeof WeixinJSBridge == "undefined") {
      d.addEventListener('WeixinJSBridgeReady', fn, false);
    } else {
      fn();
    }
  }
  export function disabledFontSize() {
    ready(() => {
      document.body.style.cssText += ';-webkit-text-size-adjust: none';
      WeixinJSBridge.invoke('setFontSizeCallback', {
        fontSize: 0,
      });
      WeixinJSBridge.on('menu:setfont', () => {
        console.warn('menu:setfont');
        // window.WeixinJSBridge.invoke("setFontSizeCallback", {
        //   fontSize: 0
        // })
      });
    });
  }
}
export namespace WechatSDK {
  export function config(options: any | {}) {
    return new Promise<void>((resolve, reject) => {
      g.wx.config(options);
      g.wx.ready(() => {
        resolve()
      })
      g.wx.error((res: any) => {
        console.error('WechatSDK.config error', res);
        reject(res);
      })
    })

  }
  export function configReady(callback: () => void) {
    if (g.wx) {
      g.wx.ready(callback);
    } else {
      //TODO 是否有必要？？
      WechatJSBridge.ready(() => {
        if (g.wx) {
          g.wx.ready(callback);
        } else {
          console.error("wechat g.wx is undefined");
        }
      })
    }
  }

  interface AppMessageShareData {
    title?: string;
    desc?: string;
    link?: string;
    imgUrl?: string;
    success?: () => void;
    fail?: () => void;
  }
  export function updateAppMessageShareData(data: AppMessageShareData) {
    if (g.wx.updateAppMessageShareData) {
      g.wx.updateAppMessageShareData(data);
    }
  }
  interface TimelineShareData {
    title?: string;
    link?: string;
    imgUrl?: string;
    success?: () => void;
    fail?: () => void;
  }
  export function updateTimelineShareData(data: TimelineShareData) {
    if (g.wx.updateTimelineShareData) {
      g.wx.updateTimelineShareData(data);
    }
  }
  export function openLocation(args: {
    latitude: number;
    longitude: number;
    address: string;
    scale: number;
  }) {
    g.wx.openLocation({
      latitude: args.latitude,
      longitude: args.longitude,
      name: args.address, // 位置名
      // address: , // 地址详情说明
      scale: args.scale, // 地图缩放级别,整型值,范围从1~28。默认为最大
      infoUrl: '', // 在查看位置界面底部显示的超链接,可点击跳转
    });
    // window.wx.openLocation({
    //     latitude: latitude,
    //     longitude: longitude,
    //     name: '', // 位置名
    //     address: address, // 地址详情说明
    //     scale: scale, // 地图缩放级别,整型值,范围从1~28。默认为最大
    //     infoUrl: '' // 在查看位置界面底部显示的超链接,可点击跳转
    // });
  }

  export function showMenuItems(items: Array<MenuItem>) {
    g.wx.showMenuItems({
      menuList: items, // 要显示的菜单项，所有 menu 项见附录3
    });
  }


  export function hideMenuItems(items: Array<MenuItem>) {
    g.wx.hideMenuItems({
      menuList: items
    })
  }
}
